import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { approveSalaryAdvance, rejectSalaryAdvance, salaryAdvanceList } from "../../../services/payroll";

const STATUS_BADGE = { pending: "bg-warning text-dark", approved: "bg-success", rejected: "bg-danger", recovered: "bg-secondary" };

export default function AdvanceList() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  useEffect(() => { loadList(); }, []);

  function loadList() {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    salaryAdvanceList(temp).then((res) => { if (res?.status) setList(res.data); });
  }

  function handleApprove(id) {
    Swal.fire({ text: "Approve this advance?", icon: "question", showCancelButton: true, confirmButtonColor: "#28a745", cancelButtonColor: "#6259ca", confirmButtonText: "Approve", allowOutsideClick: false })
      .then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("id", id);
          approveSalaryAdvance(temp).then((res) => {
            if (res?.status) { toast.success(res.message); loadList(); }
          });
        }
      });
  }

  function handleReject(id) {
    Swal.fire({
      title: "Reject Advance", input: "text", inputPlaceholder: "Reason for rejection...",
      icon: "warning", showCancelButton: true, confirmButtonColor: "#ac0404", cancelButtonColor: "#6259ca",
      confirmButtonText: "Reject", allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const temp = new FormData();
        temp.append("id", id);
        temp.append("remarks", result.value || "");
        rejectSalaryAdvance(temp).then((res) => {
          if (res?.status) { toast.success(res.message); loadList(); }
        });
      }
    });
  }

  const columnDefs = [
    { headerName: "Employee",   field: "employee_name", resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Type",       field: "employee_type", width: 100, resizable: true,
      cellRenderer: (p) => <span className={`badge ${p.value === "teacher" ? "bg-primary" : "bg-info"}`}>{p.value}</span> },
    { headerName: "Amount",     field: "amount",          width: 110, resizable: true, cellStyle: { textAlign: "right" },
      cellRenderer: (p) => parseFloat(p.value).toFixed(2) },
    { headerName: "Monthly",    field: "monthly_recovery", width: 110, resizable: true, cellStyle: { textAlign: "right" },
      cellRenderer: (p) => parseFloat(p.value).toFixed(2) },
    { headerName: "Remaining",  field: "remaining_amount", width: 110, resizable: true, cellStyle: { textAlign: "right" },
      cellRenderer: (p) => parseFloat(p.value).toFixed(2) },
    { headerName: "Req Date",   field: "request_date",  width: 115, resizable: true },
    { headerName: "Reason",     field: "reason",        resizable: true, cellStyle: { textAlign: "left" } },
    { headerName: "Status",     field: "status",        width: 110, resizable: true,
      cellRenderer: (p) => <span className={`badge ${STATUS_BADGE[p.value] || "bg-secondary"}`}>{p.value}</span> },
    {
      headerName: "Actions", field: "id", width: 130, filter: false, resizable: true,
      cellRenderer: (p) => (
        <div className="text-center">
          {p.data.status === "pending" && (
            <>
              <a onClick={() => handleApprove(p.value)} className="btn-sm btn-success me-1"><i className="fa fa-check" /></a>
              <a onClick={() => handleReject(p.value)}  className="btn-sm btn-danger"><i className="fa fa-times" /></a>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Advance List</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Payroll</a></li>
            <li className="breadcrumb-item active" aria-current="page">Advance List</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="res-right mb-2">
                <a onClick={() => navigate("/payroll/advance")} className="btn btn-success tx-teko">+ New Advance</a>
              </div>
              <div className="ag-theme-alpine ag-style">
                <AgGridReact columnDefs={columnDefs} rowData={list} pagination paginationPageSize={10} suppressDragLeaveHidesColumns />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
